/**********************************************************
Chemical View
**********************************************************/
import Tabs from '../tabs';
import { CHEMICAL_APP_URLS } from '../../cult_constants';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class ChemicalApplicationContainer extends Component {
  render() {
    return (
      <div>
        <div>
          <Tabs tabs={CHEMICAL_APP_URLS} level={this.props.user.level} />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(ChemicalApplicationContainer);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_container.js